import React, { useContext } from "react";

import {TranslationsContext} from "@proxy/_contexts";

export default function OverlayBottomRecord({
  isRecording,
  stopRecord,
  startRecord,
  timeRemaining,
  cameraReady
}) {
  const translations = useContext(TranslationsContext);

  const statusMarkup = ( isRecording ) ?
    translations.video_recorder_status_recording :
    translations.video_recorder_status_paused;

  const playbuttonMarkup = ( isRecording ) ?
    <button
      type={"button"}
      id="start-record"
      className={"gc__stop_record_button"}
      onClick={stopRecord}
    >
      <div className={"gc__record_square"}><p></p></div>
    </button> :
    <button
      type={"button"}
      id="start-record"
      className={"gc__start_record_button"}
      disabled={!cameraReady}
      onClick={startRecord}
    >
      <div className={"gc__record_dot"}><p></p></div>
    </button>

  return (
    <>
      <div className={"gc__video_pill_container"}>
        {
          isRecording ?
            <></> :
            <div className={"gc__video_pill_help_text"}>
              Video Recorder Status
            </div>
        }
        <div className={"gc__video_pill"}>
          { statusMarkup }
        </div>
      </div>

      {playbuttonMarkup}

      <div className={"gc__video_pill_container"}>
        {
          isRecording ?
            <></> :
            <div className={"gc__video_pill_help_text"}>
              Time Remaining
            </div>
        }
        <div className={"gc__video_pill"}>
          { timeRemaining }
        </div>
      </div>
    </>
  );
}
